import _ from "lodash";
import React, { useState } from "react";
import classes from "./DescriptorTable.scss";
import classNames from "classnames";
import { DownArrowOutlined, UpArrowOutlined } from "@toddle-edu/ds-icons";

const DescriptorTable = ({
  rowData,
  firstColumnTitle,
  secondColumnTitle,
  isSortingEnabled = true,
  dsVersion = "1.0",
  showRevampedUI = false,
}) => {
  const [sortingDirection, setSortingDirection] = useState("ASC");

  const updateSortingDirection = () => {
    if (_.isEqual(sortingDirection, "ASC")) setSortingDirection("DESC");
    else setSortingDirection("ASC");
  };

  const tableHeaderClass = classNames({
    [classes.tableHeader]: true,
    ["text-label-2"]: dsVersion === "1.0",
    ["text-label"]: dsVersion === "2.0",
    [classes.tableHeaderV2]: dsVersion === "2.0",
    [classes.tableHeaderRevamped]: showRevampedUI,
  });

  const columnWithSortingClass = classNames({
    [classes.headerWithSorting]: true,
    ["text-label-2"]: dsVersion === "1.0",
    ["text-label"]: dsVersion === "2.0",
    [classes.headerWithSortingV2]: dsVersion === "2.0",
    [classes.tableHeaderRevamped]: showRevampedUI,
  });

  const descriptorTableClass = classNames({
    [classes.descriptorTable]: true,
    ["text-body-2"]: dsVersion === "1.0",
    ["text-body"]: dsVersion === "2.0",
    [classes.descriptorTableV2]: dsVersion === "2.0",
  });

  const subTextClass = classNames({
    [classes.subText]: true,
    ["text-body-1"]: dsVersion === "1.0",
    ["text-body"]: dsVersion === "2.0",
  });

  const getSortingIcon = () => {
    if (isSortingEnabled) {
      _.isEqual(sortingDirection, "ASC") ? (
        <DownArrowOutlined variant="on" />
      ) : (
        <UpArrowOutlined variant="on" />
      );
    }
  };

  const achievementLevelClasses = classNames({
    ["text-label-2"]: dsVersion === "1.0",
    ["text-body"]: dsVersion === "2.0",
    [classes.achievementLevelV2]: dsVersion === "2.0",
  });

  const tableCelClasses = classNames({
    [classes.tableCell]: true,
    [classes.tableCellV2]: dsVersion === "2.0",
    ["text-body"]: dsVersion === "2.0",
  });

  return (
    <table className={descriptorTableClass}>
      <col className={classes.column1} />
      <col className={classes.column2} />
      <tr>
        <th className={columnWithSortingClass} onClick={updateSortingDirection}>
          {firstColumnTitle} &nbsp;
          {getSortingIcon()}
        </th>
        <th className={tableHeaderClass}>{secondColumnTitle}</th>
      </tr>
      {_.map(
        _.isEqual(sortingDirection, "ASC") ? rowData : [...rowData].reverse(),
        item => {
          const { achievementLevel, descriptor, subText } = item;
          return (
            <tr key={item?.id}>
              <td className={tableCelClasses}>
                <span className={achievementLevelClasses}>
                  {achievementLevel}
                </span>
                {subText && (
                  <div
                    className={subTextClass}
                    dangerouslySetInnerHTML={{ __html: subText }}
                  />
                )}
              </td>
              <td
                className={tableCelClasses}
                dangerouslySetInnerHTML={{ __html: descriptor }}
              />
            </tr>
          );
        }
      )}
    </table>
  );
};

export default DescriptorTable;
